import { Option } from "./option.js";
/**
 * @internal
 */
export var Maybe;
(function (Maybe) {
    function toOption(maybe) {
        return Option.isOption(maybe) ? maybe : Option.of(maybe);
    }
    Maybe.toOption = toOption;
})(Maybe || (Maybe = {}));
//# sourceMappingURL=maybe.js.map